<script>
    import {orderBy} from 'lodash';
    export default {
        data() {
            return {
                tableData: []
            }
        },
        computed: {
            filtered() {
                let data = this.tableData;
                data.map(item => {
                    item.dateToNumber = new Date(item.logDate).getTime();
                    item.dateString = this.formatDateWithTime(new Date(item.logDate));
                    item.splitted = item.dateString.split(' at ');
                })
                return orderBy(data, ['dateToNumber'], ['desc']);
            },
        },
        methods: {
            async getData(id){
                try{
                    const { data: response} = await this.$store.dispatch("realignmentrequest/GetRealignmentHistory", id);
                    if(response.error){
                        this.showToast(response.errorMessage, "error");
                        return;
                    }
                    console.log(response);
                    this.tableData = response;
                }catch (error){
                    console.error(error);
                    this.showToast("An error occurred while fetching data.", "error");
                }
            }
        }
    }
</script>
<template>
    <b-modal
        id="realigment-remarks-modal"
        title="Modification Remarks"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <h3 class="text-center">Modification Remarks</h3>
        <div class="d-flex justify-content-center mt-4 mx-5 px-5 mb-4">
            <ul class="verti-timeline list-unstyled" v-if="tableData.length > 0">
                <li class="event-list" v-for="(x, xIndex) in filtered" :key="x.id" :class="{'active': xIndex == 0}">
                    <div class="event-timeline-dot">
                        <i class="bx bx-right-arrow-circle font-size-18" :class="{'bx-fade-right': xIndex == 0}"></i>
                    </div>
                    <div class="media">
                        <div class="me-3">
                            <h5 class="font-size-14 mb-0">
                                {{x.splitted[0]}}
                                <i
                                    class="
                                        bx bx-right-arrow-alt
                                        font-size-16
                                        text-primary
                                        align-middle
                                        ms-2
                                    "
                                ></i>
                            </h5>
                            <small>{{x.splitted[1]}}</small>
                        </div>
                        <div class="media-body">
                            <div class="mb-0" style="line-height:14px;">{{x.remarks}}</div>
                            <div><small>({{x.loggedBy.trim()}})</small></div>
                        </div>
                    </div>
                </li>
            </ul>
            <div v-else>
                <div class="text-center d-flex align-items-center">
                    <i class="bx bx-error-circle font-size-15 text-warning me-1"></i>
                    <h4 class="text-warning mb-0">No data found.</h4>
                </div>
            </div>
        </div>
    </b-modal>
</template>